import Dexie from 'dexie'
import moment from 'moment'

export default class DexieClient {
  constructor() {
    this._db = new Dexie('Sharewind')
    this._db.version(1).stores({
      linkPreviews: 'id, image, favicon, title, description, exp',
    })

    this.cleanExpiredLinkPreviews()

    this._db.linkPreviews.putWithExp = function(item) {
      this.put({
        exp: moment(new Date()).add(1,'months').toDate(),
        ...item
      })
    }
  }

  cleanExpiredLinkPreviews() {
    this._db.linkPreviews.where('exp').below(new Date()).delete()
  }

  get linkPreviews() {
    return this._db.linkPreviews
  }
}
